import { render } from "./MassMedia.vue?vue&type=template&id=52d4f362"
import script from "./MassMedia.vue?vue&type=script&lang=js"
export * from "./MassMedia.vue?vue&type=script&lang=js"

import "./MassMedia.vue?vue&type=style&index=0&id=52d4f362&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__